const CSV_DELIMITERS = [',', ';', '\t'];

const countOutsideQuotes = (line: string, delimiter: string): number => {
  let count = 0;
  let inQuotes = false;
  for (const char of line) {
    if (char === '"') {
      inQuotes = !inQuotes;
    } else if (char === delimiter && !inQuotes) {
      count++;
    }
  }
  return count;
};

// Excel saves CSV files with the system list separator, which is ';' on
// Swedish systems, so the delimiter is read from the header row.
export const detectCsvDelimiter = (text: string): string => {
  const headerLine = text.split(/\r?\n/, 1)[0] ?? '';
  return CSV_DELIMITERS.reduce((best, delimiter) =>
    countOutsideQuotes(headerLine, delimiter) >
    countOutsideQuotes(headerLine, best)
      ? delimiter
      : best,
  );
};

export const parseCsv = (text: string): string[][] => {
  const content = text.replace(/^\uFEFF/, '');
  if (content.trim() === '') return [];

  const delimiter = detectCsvDelimiter(content);
  const rows: string[][] = [];
  let row: string[] = [];
  let field = '';
  let inQuotes = false;

  for (let i = 0; i < content.length; i++) {
    const char = content[i];

    if (inQuotes) {
      if (char === '"' && content[i + 1] === '"') {
        field += '"';
        i++;
      } else if (char === '"') {
        inQuotes = false;
      } else {
        field += char;
      }
    } else if (char === '"') {
      inQuotes = true;
    } else if (char === delimiter) {
      row.push(field);
      field = '';
    } else if (char === '\n' || char === '\r') {
      if (char === '\r' && content[i + 1] === '\n') i++;
      row.push(field);
      rows.push(row);
      row = [];
      field = '';
    } else {
      field += char;
    }
  }

  row.push(field);
  rows.push(row);
  return rows;
};
